import useAuth from '@sdk/authentication/useAuth';
import { Feature } from '@sdk/common/features';

import usePremiumGuard from '@web/premiumGuard/usePremiumGuard';
import { PremiumModalNames } from '@web/premiumGuard/constants/modalNames';
import { BREAK_AUTOMATION_OPTIONS } from '@web/settings/components/schedule/Breaks/breaks.consts';

export const useBreakAutomationOptions = () => {
  const { currentUser } = useAuth();
  const { openPremiumGuardModal } = usePremiumGuard();

  const breakAutomationOptions = BREAK_AUTOMATION_OPTIONS.map((option) => ({
    ...option,
    disabled: !!option.value && !currentUser.org.isPremium,
  }));

  const showPremiumModal = () => {
    openPremiumGuardModal({
      premiumFeatureName: PremiumModalNames.automatedBreaks,
      premiumFeature: Feature.automatedBreaks,
    });
  };

  return {
    breakAutomationOptions,
    showPremiumModal,
  };
};
